import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  show(slug) {
    const url = apiRoutes.apiV1PublicRealEstateAgentsPath(slug);

    return FetchHelpers.get(url);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/public/RealEstateAgentsRepository.js